import React from 'react';

import { StoreProps } from './types';

export const Store = ({ children }: StoreProps) => {
    return <>{children}</>;
};
